import { create } from "zustand";

interface SocialStore {
  collaborators: any[];
  setCollaborators: (collaborators: any[]) => void;

  clients: any[];
  setClients: (clients: any[]) => void;
  
  formData: Record<string, any>;
  setFormData: (formData: Record<string, any>) => void;

  dataSocialFilter: any[];
  setDataSocialFilter: (dataSocialFilter: any[]) => void;

  clientFiles: any[];
  setClientFiles: (clientFiles: any[]) => void;

  checkboxValuesCollabs: any[];
  setCheckboxValuesCollabs: (checkboxValuesCollabs: any[]) => void;

  socialContacts: any[];
  setSocialContacts: (socialContacts: any[]) => void;

  updateSocial: boolean;
  setUpdateSocial: (updateSocial: boolean) => void;

  tabSocial: string;
  setTabSocial: (tabSocial: string) => void;

  employees : any[];
  setEmployees: (employees: any[]) => void;

  idCustomer: number;
  setIdCustomer: (idCustomer: number) => void;

  idEmployee: number;
  setIdEmployee: (idEmployee: number) => void;

  tabElements: string;
  setTabElements: (tabElements: string) => void;

  typesInputValeur: any[];
  setTypesInputValeur: (typesInputValeur: any[]) => void;

  formDataDetails: any;
  setFormDataDetails: (formDataDetails: any) => void;

  isOverlap: boolean;
  setIsOverlap: (isOverlap: boolean) => void;

  messages: any[];
  setMessages: (messages: any[]) => void;

  historyMessages: any[];
  setHistoryMessages: (historyMessages: any[]) => void;

  numberOfBulletins: number;
  setNumberOfBulletins: (numberOfBulletins: number) => void;
  
  customer: any;
  setCustomer: (customer: any) => void;

  formDataSimulator: any;
  setFormDataSimulator: (formDataSimulator: any | ((prev: any) => any)) => void;

  formDataByCustomer: any;
  setFormDataByCustomer: (formDataByCustomer: any) => void;

  annual: boolean;
  setAnnual: (annual: boolean) => void;

  lastRefusedDate: string;
  setLastRefusedDate: (lastRefusedDate: string) => void;

  allData: any;
  setAllData: (allData: any) => void;

  isCompleted: boolean;
  setIsCompleted: (isCompleted: boolean) => void;

  resetSocial: () => void
}

export const useSocialStore = create<SocialStore>((set) => ({
  collaborators: [],
  setCollaborators: (collaborators: any[]) => set({ collaborators }),

  clients: [],
  setClients: (clients: any[]) => set({ clients }),

  formData: {},
  setFormData: (formData) => set({formData}),

  dataSocialFilter: [],
  setDataSocialFilter: (dataSocialFilter: any[]) => set({ dataSocialFilter }),

  clientFiles: [],
  setClientFiles: (clientFiles: any[]) => set({ clientFiles }),

  checkboxValuesCollabs: [],
  setCheckboxValuesCollabs: (checkboxValuesCollabs: any[]) => set({ checkboxValuesCollabs }),

  socialContacts: [],
  setSocialContacts: (socialContacts: any[]) => set({ socialContacts }),

  updateSocial: false,
  setUpdateSocial: (updateSocial: boolean) => set({updateSocial}),

  tabSocial: 'Dossier clients social',
  setTabSocial: (tabSocial) => set({tabSocial}),

  employees : [],
  setEmployees: (employees: any[]) => set({ employees }),

  idCustomer: 0,
  setIdCustomer: (idCustomer: number) => set({ idCustomer }),
  
  idEmployee: 0,
  setIdEmployee: (idEmployee: number) => set({idEmployee}),

  tabElements: "Absences",
  setTabElements: (tabElements: string) => set({tabElements}),

  typesInputValeur: [],
  setTypesInputValeur: (typesInputValeur: any[]) => set({typesInputValeur}),

  formDataDetails: {},
  setFormDataDetails: (formDataDetails: any) => set({formDataDetails}),

  isOverlap: false,
  setIsOverlap: (isOverlap: boolean) => set({isOverlap}),

  messages: [],
  setMessages: (messages: any[]) => set({messages}),
  
  historyMessages: [],
  setHistoryMessages: (historyMessages: any[]) => set({historyMessages}),

  numberOfBulletins: 0,
  setNumberOfBulletins: (numberOfBulletins: number) => set({numberOfBulletins}),

  customer: {},
  setCustomer: (customer: any) => set({customer}),

  formDataSimulator: {},
  setFormDataSimulator: (formDataSimulator: any | ((prev: any) => any)) => 
    set((state) => ({
      formDataSimulator: typeof formDataSimulator === 'function' 
        ? formDataSimulator(state.formDataSimulator) 
        : formDataSimulator
    })),

  formDataByCustomer: {},
  setFormDataByCustomer: (formDataByCustomer: any) => set({formDataByCustomer}),

  annual: false,
  setAnnual: (annual: boolean) => set({annual}),

  lastRefusedDate: "",
  setLastRefusedDate: (lastRefusedDate: string) => set({lastRefusedDate}),

  allData: {},
  setAllData: (allData: any) => set({allData}),

  isCompleted: false,
  setIsCompleted : (isCompleted :boolean) => set({isCompleted}),

  resetSocial: () => set({
    clients: [],
    collaborators: [],
    checkboxValuesCollabs: [],
    socialContacts: [],
    tabSocial: 'Dossier clients social',
    updateSocial: false,
    employees: [],
    idEmployee:0,
    idCustomer: 0,
    tabElements: "Absences",
    typesInputValeur: [],
    formDataDetails: {},
    isOverlap: false,
    messages: [],
    historyMessages: [],
    numberOfBulletins: 0,
    customer: {},
    formDataSimulator: {},
    annual: false,
    formDataByCustomer: {},
    lastRefusedDate: "",
    allData: {},
    isCompleted: false,
  })
}));
